import { render, staticRenderFns } from "./NewlySite.vue?vue&type=template&id=47075e2c&scoped=true"
import script from "./NewlySite.vue?vue&type=script&lang=js"
export * from "./NewlySite.vue?vue&type=script&lang=js"
import style0 from "./NewlySite.vue?vue&type=style&index=0&id=47075e2c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47075e2c",
  null
  
)

export default component.exports